import React, { useRef, useEffect, useLayoutEffect, useState } from "react";
import "./MobileScrollCarousel.css";
import { trackEdgeFade } from "./edgeFade";

const MobileScrollCarousel = ({
  children,
  itemWidth,
  itemMaxWidth,
  arrowBottom,
  className = "",
  containerClassName = "",
  fadeImages = false,
  textOverImage = false,
}) => {
  const scrollRef = useRef(null);
  const childCount = React.Children.count(children);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateArrowVisibility = () => {
    const container = scrollRef.current;
    if (!container) return;
    setCanScrollLeft(container.scrollLeft > 10);
    setCanScrollRight(
      container.scrollLeft < container.scrollWidth - container.clientWidth
    );
  };

  useLayoutEffect(() => {
    if (fadeImages && scrollRef.current) return trackEdgeFade(scrollRef.current);
  }, [fadeImages]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    updateArrowVisibility();
    container.addEventListener("scroll", updateArrowVisibility);
    window.addEventListener("resize", updateArrowVisibility);
    return () => {
      container.removeEventListener("scroll", updateArrowVisibility);
      window.removeEventListener("resize", updateArrowVisibility);
    };
  }, []);

  const scrollByOneItem = (direction) => {
    const container = scrollRef.current;
    if (!container) {
      return;
    }

    const firstItem = container.firstElementChild;
    if (!firstItem) {
      return;
    }

    const computed = window.getComputedStyle(container);
    const gapValue = computed.gap || computed.columnGap || "0px";
    const gap = Number.parseFloat(gapValue) || 0;
    const amount = firstItem.getBoundingClientRect().width + gap;

    container.scrollBy({ left: direction * amount, behavior: "smooth" });
  };

  const showLeft = childCount > 1 && canScrollLeft;
  const showRight = childCount > 1 && canScrollRight;
  const wrapperClassName = [
    "mobile-scroll-wrapper",
    className,
    showLeft && "can-scroll-left",
    showRight && "can-scroll-right",
    textOverImage && "text-over-image",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={wrapperClassName}
      style={{ "--mobile-arrow-bottom": arrowBottom }}
    >
      {showLeft && (
        <button
          type="button"
          className="mobile-arrow mobile-arrow-left"
          aria-label="Scroll left"
          onClick={() => scrollByOneItem(-1)}
        >
          <span className="mobile-chevron">‹</span>
        </button>
      )}
      <div
        ref={scrollRef}
        className={`mobile-scroll-container ${fadeImages ? "edge-fade-box" : ""} ${containerClassName}`
          .replace(/\s+/g, " ")
          .trim()}
        style={{
          "--mobile-scroll-item-width": itemWidth,
          "--mobile-scroll-item-max-width": itemMaxWidth,
        }}
      >
        {children}
      </div>
      {showRight && (
        <button
          type="button"
          className="mobile-arrow mobile-arrow-right"
          aria-label="Scroll right"
          onClick={() => scrollByOneItem(1)}
        >
          <span className="mobile-chevron">›</span>
        </button>
      )}
    </div>
  );
};

export default MobileScrollCarousel;
